export enum COMMANDE_ROUTES {
  GET_ALL = "/commande",
  GET = "/commande/",
  CREATE = "/commande",
  UPDATE = "/commande/",
  REMOVE = "/commande/",
  UPLOAD_DOCUMENT = "/commande/"
}
